<template>
  <div class="app">
    <Header />
    <div class="main">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue';
import Header from "./components/Header.vue"
  export default {
    name: 'app',
    data(){
      return {

      }
    },
    methods: {
     
    },
    created() {
      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload", () => {
        localStorage.setItem("messageStore", JSON.stringify(this.$store.state))
      })
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("messageStore") && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem("messageStore"))));
    },
    components: {
      Header,
      Footer
    }
  }
</script>

<style lang="less" scoped>
  @import 'assets/css/base.css';
  .main {
    background-size: 118%;
    background-image: url('./assets/img/index/02.jpg');
    background-position-y: -10px;
    padding-top: 40px;
    padding-bottom: 80px;
  }
</style>
